import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/tags',
  	  method: 'get',
        params
  	})
  }

export function show(id) {
    return request({
      url: `/tags/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/tags',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/tags/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/tags/${id}`,
      method: 'delete',
    })
  }
